import React from "react"

export default class MultipleChoice extends React.Component {
	
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
	}

	render() {
		// console.log('render MultipleChoice', this.props)
		var answers = this.props.answers.map((answer) => {
			return this.renderAnswer(answer);
		});

		return (
			<div className="MultipleChoice">
				{answers}
			</div>
		);
	}

	renderAnswer(answer) {
		// console.log('renderAnswer', answer, this.props.value === answer.value)
		return (
			<label className="MultipleChoiceAnswer" key={answer.value}>
				<input type={this.props.type} 
							 value={answer.value} 
							 name={this.props.question.id} 
							 onChange={this.onChange} 
							 checked={this.props.value === answer.value} 
				/>
				<div className="MultipleChoiceAnswerLabel">{answer.label}</div>
			</label>
		);
	}

	/**
	* Change Handlers
	*/
 
	onChange(e) {
		this.props.onChange('MULTIPLE_CHOICE', this.props.question.id, {options: [{id: e.target.value}]})
	}

}